module.exports = __webpack_public_path__ + "static/media/dp.3c71efe2.jpg";